import React from 'react'
import styled from 'styled-components/native'

import I18n from 'APP/I18n'
import Button from 'APP/Converse/Button'
import { FormStep } from 'APP/Components/AddDependent/types'

type FooterProps = {
  isDisabled?: boolean
  onSubmit: () => void
  currentStep: FormStep
}

const FooterContainer = styled.View`
  align-items: center;
  gap: ${({ theme }) => theme.metrics.baseMargin};
  padding: 20px;
`

export const Footer = ({ isDisabled = false, onSubmit, currentStep }: FooterProps) => (
  <FooterContainer>
    <Button
      variant="primary"
      widthVariant="full"
      title={String(I18n.t('FamilyScreen.AddFamilyMemberScreen.footer', { context: currentStep }))}
      onPress={onSubmit}
      disabled={isDisabled}
      analyticsName={`AddFamilyMember.${currentStep}.cta`}
      testID="ADD_FAMILY_MEMBER_CTA"
    />
  </FooterContainer>
)

export default Footer
